import { render, staticRenderFns } from "./teacherEdit.vue?vue&type=template&id=5ff6ac7c&scoped=true&"
import script from "./teacherEdit.vue?vue&type=script&lang=js&"
export * from "./teacherEdit.vue?vue&type=script&lang=js&"
import style0 from "./teacherEdit.vue?vue&type=style&index=0&id=5ff6ac7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff6ac7c",
  null
  
)

export default component.exports